import React, { Component } from 'react'
import NavigationAppShell from '../../common/navigation-app-shell'
import SubscriptionCards from './containers/subscription-cards'
import EditSubscriptionDialog from './containers/edit-subscription-dialog'
import NewSubscriptionDialog from './containers/new-subscription-dialog'
import DeleteSubscriptionDialog from './containers/delete-subscription-dialog'

class SubscriptionsPage extends Component {
  handleReload = () => {
    this.props.history.push('/subscriptions')
  }

  changeUrl = url => {
    this.props.history.push(url)
  }

  render () {
    return (
      <NavigationAppShell
        content={
          <div>
            <SubscriptionCards changeUrl={this.changeUrl} />
            <EditSubscriptionDialog handleReload={this.handleReload} />
            <NewSubscriptionDialog handleReload={this.handleReload} />
            <DeleteSubscriptionDialog handleReload={this.handleReload} />
          </div>
        }
        pageName={'Subscriptions'}
      />
    )
  }
}

export default SubscriptionsPage



// WEBPACK FOOTER //
// ./src/pages/subscriptions/index.js